export default __webpack_public_path__ + "images/assets/05cced119b766a6b4da0410307835c86.svg";